<!--
 * @Author: ymk
 * @Date: 2020-07-23 09:52:48
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-24 18:30:54
 * @FilePath: \car-demo\src\App.vue
-->
<template>
	<div id="MaintainVipCode" >
        <div class="box">
		    <div class="tips">我的会员码</div>
            <div class="tips2">{{nickname}}</div>
            <div class="tips2">{{mobile}}</div>
            <img :src="code_url"/>
			<div class="tips3">已开通车之驭会员</div>
        </div>
	</div>
</template>

<script>


export default {
	name: 'MaintainVipCode',
	components:{
		
	},
	metaInfo: {
		title: '我的会员码',
		titleTemplate: null,
	},
	components: {
	},
	data: () => ({
		code_url:'',
        nickname:'',
        mobile:'',
        showContent:false,
	}),
    created(){
		var that =this;
        that.nickname = that.$route.query.nickname?that.$route.query.nickname:'待设置';
        that.mobile = that.$route.query.mobile?that.$route.query.mobile:'';
         that.code_url = 'http://m.ewm.ccoo.cn/qrimg.ashx?scale=165&codeStr=核验成功';

    },
	mounted() {
		
	},
	methods: {

		
	},
}
</script>

<style lang="less">

.box{
    margin-top: 90px;
    text-align: center;
}
.tips{
    margin-bottom: 30px;
    font-size: 18px;
}
.tips2{
    margin-bottom: 10px;
    font-size: 24px;
}
.tips3{
    margin-top: 30px;
    font-size: 18px;
}
.val-content {
        width: 50%;
        height: 40px;
        flex: 1;
        border-bottom: 1px #ccc solid;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 24%;
		margin-top: 20px;
        .input {
          font-size: 14px;
          color: #666;
          flex: 1;
        }

        span {
          font-size: 14px;
          color: #3c43ec;
        }
      }

	  .business_tips{
			margin-top: 50%;
		}
</style>
